export default __webpack_public_path__ + "static/media/7.14fd00df.jpg";